<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <div class="col">
      <form class="container-style needs-validation" [formGroup]="formProviderNote" novalidate>
        <div class="ps-2 pe-1 mb-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" (onClick)="goToBack($event)" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>
            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <app-custom-button [title]="'Eliminar'" [severity]="'contrast'" [icon]="'pi pi-trash'"
                (onClick)="deleteProviderNote()"></app-custom-button>
              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
                (onClick)="createNewProviderNote()"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col">
              <app-custom-audit-info [userNameCreate]="providerNoteModel.userNameCreate"
                [createDate]="providerNoteModel.createDate" [userNameUpdate]="providerNoteModel.userNameUpdate"
                [updateDate]="providerNoteModel.updateDate" [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <div class="row">
            <div class="col field-branch">
              <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranch"
                [required]="true" (onChangeSelect)="changeBranch($event)"></app-custom-select>
            </div>
            <div class="col field-consecutive">
              <app-custom-input-number formControlName="consecutive"
                [labelText]="'Consecutivo'"></app-custom-input-number>
            </div>
            <div class="col field-provider">
              <app-custom-autocomplete formControlName="providerId" [labelText]="'Proveedor'" [list]="listProvider"
                [recovery]="true" [required]="true" (onChangeSelect)="changeProvider($event)"></app-custom-autocomplete>
            </div>
            <div class="col field-prefix">
              <app-custom-input-text formControlName="prefix" [labelText]="'Prefijo'" [maxLength]="6" [recovery]="true"
                (onChangeTextOnBlur)="changePrefixNoteNumber()"></app-custom-input-text>
            </div>
            <div class="col field-note-number">
              <app-custom-input-number formControlName="noteNumber" [labelText]="'Número Nota'" [required]="true"
                [recovery]="true" (onChangeNumber)="changePrefixNoteNumber()"></app-custom-input-number>
            </div>
            <div class="col field-change-prefix-number d-flex align-items-end">
              <div class="d-flex justify-content-center">
                <app-custom-button [label]="'Cambiar Nro.Nota'" [severity]="'success'" [width]="'8rem'"
                  (onClick)="openPrefixNoteNumberModal()"></app-custom-button>
                <app-custom-modal #prefixNoteNumberModal [label]="'Cambiar Nro.Nota'" [header]="'Cambiar Nro.Nota'"
                  [inputs$]="inputsForPrefixNoteNumberModal$" [children]="componentPrefixNoteNumberModal"
                  [width]="'30rem'" [closable]="false" [focusShow]="false" (params)="reloadProviderNote($event)" hidden>
                </app-custom-modal>
              </div>
            </div>
            <div class="col field-state">
              <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateString"></app-custom-tag>
            </div>
            <div class="col field-state-button d-flex align-items-end mt-1">
              <app-custom-button [icon]="iconState" [title]="titleState" [severity]="'primary'"
                (onClick)="changeState()"></app-custom-button>
            </div>
          </div>
          <div class="row">
            <div class="col field-note-type">
              <app-custom-select formControlName="noteType" [labelText]="'Tipo Nota'" [list]="listNoteTypeFiltered"
                [required]="true"></app-custom-select>
            </div>
            <div class="col field-date">
              <app-custom-datepicker formControlName="date" [labelText]="'Fecha'"
                [required]="true"></app-custom-datepicker>
            </div>
            <div class="col field-provider-invoice">
              <app-custom-inputgroup [inputValue]="prefixNumberInvoice" [labelText]="'Factura Afectada'"
                [showClear]="true" [iconButton]="'pi pi-external-link'" [titleButton]="'Seleccionar Factura Afectada'"
                [required]="true" [disabled]="afectedInvoiceDisabled" (onClick)="openInvoiceSelectionModal()"
                (valueChange)="onInvoiceValueChange($event)"></app-custom-inputgroup>
              <app-custom-modal #selectInvoice [label]="'Seleccionar'" [header]="'Selección de Factura Proveedor'"
                [children]="componentInvoiceSelection" [inputs$]="inputsForSelectInvoiceModal$" [output$]="output$"
                [width]="'60rem'" (selectedItems)="setInvoiceEnterprise($event)" hidden></app-custom-modal>
            </div>
            <div class="col field-iva-type">
              <app-custom-input-text [value]="ivaType" [labelText]="'Tipo IVA'"
                [disabled]="true"></app-custom-input-text>
            </div>
            <div class="col field-enterprise">
              <app-custom-input-text [value]="enterpriseCodeName" [labelText]="'Empresa'"
                [disabled]="true"></app-custom-input-text>
            </div>
          </div>
          <div class="row">
            <div class="col field-observation">
              <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [autoResize]="false"
                [rows]="1" [maxLength]="90"></app-custom-textarea>
            </div>
            <div class="col field-save-button d-flex align-items-end justify-content-end mt-2">
              <app-custom-button [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                [disabled]="disabledForm" (onClick)="send()"></app-custom-button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col container-style mt-2 pb-2">
    <app-provider-note-detail [providerNoteModel]="providerNoteModel" [isFormView]="isFormView"
      [updateListDetail]="updateListDetail" [disableDetail]="disabledForm" [permissionUpdatable]="permissionUpdatable"
      (updateProviderNote)="getUpdateProviderNote($event)">
    </app-provider-note-detail>
  </div>
  <!-- Valores de la nota proveedor -->
  <form class="needs-validation container-style mt-2" [formGroup]="formProviderNoteFooter">
    <div class="col-lg-12 col-12">
      <div class="row">
        <div class="col fields-values">
          <app-custom-input-decimal formControlName="subtotalValue" [labelText]="'Subtotal'"></app-custom-input-decimal>
        </div>
        <div class="col fields-values">
          <app-custom-input-decimal formControlName="ivaValue" [labelText]="'Vr.Iva'"></app-custom-input-decimal>
        </div>
        <div class="col fields-values">
          <app-custom-input-decimal formControlName="retentionValue"
            [labelText]="'Vr.Retenciones'"></app-custom-input-decimal>
        </div>
        <div class="col fields-values">
          <app-custom-input-decimal formControlName="paymentValue"
            [labelText]="'Valor Abonado'"></app-custom-input-decimal>
        </div>
        <div class="col fields-values">
          <app-custom-input-decimal formControlName="residueValue" [labelText]="'Saldo'"></app-custom-input-decimal>
        </div>
        <div class="col field-total-to-pay">
          <app-custom-tag [label]="'Total a Pagar'"
            [value]="(providerNoteModel.subtotalValue + providerNoteModel.ivaValue - providerNoteModel.retentionValue | number:'1.2-2') + ' - ' + (providerNoteModel.provider?.currency?.code ?? '')"></app-custom-tag>
        </div>
        <div class="col field-taxs d-flex align-items-end mt-2">
          <app-custom-button [label]="'Impuestos'" [severity]="'success'" [width]="'6rem'"
            (onClick)="openRetentionsModal()"></app-custom-button>
          <app-custom-modal #retentionsModal [label]="'Impuestos y Retenciones'" [header]="'Impuestos y Retenciones'"
            [inputs$]="inputsForRetentionsModal$" [children]="componentRetentionsModal" [width]="'70rem'"
            [closable]="false" [focusShow]="false" (params)="reloadProviderNote($event)" hidden>
          </app-custom-modal>
        </div>
      </div>
    </div>
  </form>
</section>

<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1 text-danger"> highlight_off </span>
  <h6 class="text-danger">No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>